import type { WorkspaceSortDir } from '@/components/workspace/useTableSort';

export type WorkspaceColumnMenuAction = 'freeze' | 'asc' | 'desc';

export function isColumnMenuOptionSelected(
  optionId: WorkspaceColumnMenuAction,
  {
    columnId,
    sortBy,
    sortDir,
    isFrozen,
  }: {
    columnId: string;
    sortBy?: string;
    sortDir?: WorkspaceSortDir;
    isFrozen: boolean;
  }
): boolean {
  if (optionId === 'freeze') return isFrozen;
  if (optionId === 'asc') return sortBy === columnId && sortDir === 'asc';
  if (optionId === 'desc') return sortBy === columnId && sortDir === 'desc';
  return false;
}
